import { t } from "i18next";
import { NavItem } from "@/interfaces/components/nav_item";
import { Dashboard, Events, Notebook, Restaurant, User } from "@carbon/icons-react";

const useNavigationItems = (): Array<NavItem> => {
    const NavItems: Array<NavItem> = [
        {
            "label": t('navigation.dashboard'),
            "startIcon": <Dashboard />,
            "path": "/dashboard",
        },
        {
            "label": t('navigation.coachManagement'),
            "startIcon": <User />,
            "path": "/coach/list",
            "tabsRoot": "/coach"
        },
        {
            "label": t('navigation.clientManagement'),
            "startIcon": <Events />,
            "path": "/client/list",
            "tabsRoot": "/client"
        },
        {
            "label": t('navigation.libraryManagement'),
            "startIcon": <Notebook />,
            "path": "/library",
            "children" : [
                {
                    "label": t('navigation.recipes'),
                    "startIcon": <Restaurant />,
                    "path": "/library/recipes"
                },
            ]
        }
    ];

    return NavItems;
}

export default useNavigationItems;